import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { SvgIconComponent } from '@3ddv/software-division-components/generic/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [PaginationComponent],
  imports: [ButtonComponent, SvgIconComponent, CommonModule],
  exports: [PaginationComponent],
})
export class PaginationModule {}
